import { render, staticRenderFns } from "./Page-2.vue?vue&type=template&id=72ddc0f0&scoped=true&"
var script = {}
import style0 from "./Page-2.vue?vue&type=style&index=0&id=72ddc0f0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ddc0f0",
  null
  
)

export default component.exports